<div class="side">
    <div class="close">
        <mat-icon (click)="onClose()">close</mat-icon>
    </div>
    <ng-container [dynamic]="data()"></ng-container>
</div>
